import * as MUTATIONS from '@/store/constants/mutations.js';
import moment from 'moment';

export const mutations = {
    [MUTATIONS.UPDATE_CURRENT_TIME](state) {
        state.current = moment().valueOf();
    },
    [MUTATIONS.UPDATE_PREVIOUS_TIME](state) {
        state.previous = state.current;
    },
    [MUTATIONS.UPDATE_LAST_ACTIVE](state) {
        state.last_active = state.current;
    },
    [MUTATIONS.SET_INACTIVE](state, is_inactive) {
        state.is_inactive = is_inactive;
    },
    [MUTATIONS.INCREMENT_TIME](state, { key, time }) {
        state[key] = (state[key] || 0) + time;
    },
    [MUTATIONS.RESET_TIME](state, key) {
        state[key] = 0;
    },
    [MUTATIONS.CLEAR_EVENT_HISTORY](state) {
        state.event_history = [];
    },
    [MUTATIONS.ADD_EVENT_TO_HISTORY](state, event) {
        state.event_history.push({
            event,
            timestamp: Date.now(),
        });
    },
};
